export default __webpack_public_path__ + "static/media/product_dummy_2.0532bbe7.jpg";